import { useCallback, useEffect, useState } from "react";

export const PASSWORD_RESET_COOLDOWN_MS = 60_000;
const keyFor = (email: string) => `vendistri.passwordResetCooldown:${email.trim().toLowerCase()}`;
export function readPasswordResetCooldown(email: string): number {
  try {
    const deadline = Number(window.localStorage.getItem(keyFor(email)));
    return Number.isFinite(deadline) && deadline > Date.now() ? deadline : 0;
  } catch { return 0; }
}
export function usePasswordResetCooldown(email: string) {
  const [deadline, setDeadline] = useState(() => readPasswordResetCooldown(email));
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const refresh = () => { setDeadline(readPasswordResetCooldown(email)); setNow(Date.now()); };
    refresh();
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    return () => { window.removeEventListener("storage", refresh); window.removeEventListener("focus", refresh); };
  }, [email]);
  useEffect(() => {
    if (deadline <= Date.now()) return;
    const timer = window.setInterval(() => {
      const time = Date.now();
      setNow(time);
      if (time >= deadline) window.clearInterval(timer);
    }, 1_000);
    return () => window.clearInterval(timer);
  }, [deadline]);
  const start = useCallback(() => {
    const time = Date.now();
    const next = time + PASSWORD_RESET_COOLDOWN_MS;
    try { window.localStorage.setItem(keyFor(email), String(next)); } catch { /* Keep the in-memory cooldown when storage is unavailable. */ }
    setNow(time); setDeadline(next);
  }, [email]);
  return { remainingSeconds: Math.max(0, Math.ceil((deadline - now) / 1_000)), start };
}
